export default `# See instructions here:
https://mvnrepository.com/artifact/io.jsonwebtoken/jjwt/0.7.0`;
